export default __webpack_public_path__ + "static/media/myTask-active.977a6b74.svg";